const STRING_FIELD_TYPE = 'string'
const TEXT_FIELD_TYPE = 'text'
const NUMBER_FIELD_TYPE = 'number'
const DATE_FIELD_TYPE = 'date'

const assetInventory = {
  STRING_FIELD_TYPE,
  TEXT_FIELD_TYPE,
  NUMBER_FIELD_TYPE,
  DATE_FIELD_TYPE,
}

export default assetInventory
